export const LOGIN_ROUTES = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/forgot-password/new',
  /** Old registration path, not removed for the time being since not sure if it's used in emails of elsewhere */
  FTN_AUTH: '/ftn-authenticate',
  /** New registration path */
  SIGNUP: '/signup/authenticate',
  QUICK_SIGNUP: '/signup/authenticate/success',
  /** New routes */
  CREATE_ACCOUNT: '/signup/create-account',
  /** Email verification for users who tried to log in before finishing their registration */
  COMPLETE_REGISTRATION: '/signup/complete-registration',
} as const;

export enum REGISTRATION_TYPES {
  QUICKLINK = 'invitationToken',
  RESIDENT_INVITE = 'InviteSignUp',
  TUPAS_SIGNUP = 'Tupas',
  BASIC_USER_TUPAS = 'BasicUserTupasSignUp',
}
